<div class="container">
  <div class="game-details-container">
    <ng-container
      *ngIf="{
        currentGames: currentGames$ | async,
        futureGames: futureGames$ | async,
      } as games"
    >
      <!-- CURRENT GAMES -->
      <ng-container *ngIf="games.currentGames?.length > 0; else checkFuture">
        <fgb-fantasy-game-panel [games]="games.currentGames"></fgb-fantasy-game-panel>
      </ng-container>

      <!-- FUTURE GAMES -->
      <ng-template #checkFuture>
        <ng-container *ngIf="games.futureGames?.length > 0; else noGames">
          <fgb-fantasy-game-panel [games]="games.futureGames" [isFutureGame]="true"></fgb-fantasy-game-panel>
        </ng-container>
      </ng-template>

      <!-- NO GAMES -->
      <ng-template #noGames>
        <div class="no-items w-100 text-center bg-primary">
          <div class="svg svg-info vs-svg ms-auto me-autoo" fgbAnimateSvg>
            <img [src]="'placeholders/pick-a-player.svg' | contentAssetImage" />
          </div>
          <p class="text-center font-size-14 mt-2 mb-0 text-white">
            {{ 'pick.player.placeholder.description' | translate }}
          </p>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <ng-container *ifScreenSize="screenType.Desktop">
    <div class="points-leaderboard-container d-flex flex-column">
      <div class="points-container d-flex flex-row justify-content-between bg-primary align-items-center">
        <div class="points-details d-flex flex-column">
          <p class="font-size-16 text-uppercase text-white fw-bold mb-0 fantasy-subheading">
            {{ 'fantasy.total.points' | translate }}
          </p>

          <p class="font-size-32 text-white fw-bold mb-0 fantasy-values">{{ currentUser?.Points || 0 }}</p>
        </div>
        <div class="rank-icon">
          <span class="material-symbols-outlined"> trending_up </span>
        </div>
      </div>

      <div class="leaderboard-container d-flex flex-column bg-primary">
        <div class="leaderboard-upper-details d-flex flex-row justify-content-between align-items-center">
          <div class="rank-details d-flex flex-column">
            <p class="font-size-16 text-uppercase text-white fw-bold mb-0 fantasy-subheading">
              {{ 'fantasy.season.rank' | translate }}
            </p>

            <p class="font-size-32 text-white fw-bold mb-0 fantasy-values">{{ currentUser?.Position || '-' }}</p>
          </div>
          <div class="rank-icon">
            <span class="material-symbols-outlined"> crown </span>
          </div>
        </div>

        <div class="leaderboard-data-container">
          <fgb-leaderboard
            [isSmallVersion]="true"
            [isLeaderboard]="true"
            [toShow]="20"
            [LeaderboardType]="LeaderboardType"
          ></fgb-leaderboard>
        </div>
      </div>
    </div>
  </ng-container>
</div>
